var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-drawer", {
    attrs: {
      title: "个性化配置",
      placement: "right",
      visible: _vm.settingVisible,
      width: 325
    },
    on: {
      close: function ($event) {
        _vm.settingVisible = false;
      }
    }
  }, [_c("div", {
    staticClass: "item-setting"
  }, [_c("p", [_vm._v("主题配置")]), _c("a-radio-group", {
    attrs: {
      "button-style": "solid",
      value: _vm.theme
    },
    on: {
      change: _vm.changeTheme
    }
  }, _vm._l(_vm.customList, function (item) {
    return _c("a-radio-button", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1), _c("div", {
    staticClass: "item-setting"
  }, [_c("p", [_vm._v("布局方式")]), _c("a-radio-group", {
    attrs: {
      value: _vm.layout,
      "button-style": "solid"
    },
    on: {
      change: _vm.changeLayout
    }
  }, _vm._l(_vm.layoutList, function (item) {
    return _c("a-radio-button", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1), _c("div", {
    staticClass: "item-setting flex justify-between"
  }, [_vm._v(" 开启标签页 "), _c("a-switch", {
    attrs: {
      checked: _vm.tagShow,
      "checked-children": "开",
      "un-checked-children": "关"
    },
    on: {
      change: _vm.changeTag
    }
  })], 1), _c("div", {
    staticClass: "item-setting flex justify-between"
  }, [_vm._v(" 固定头部 "), _c("a-switch", {
    attrs: {
      checked: _vm.fixHeader,
      "checked-children": "开",
      "un-checked-children": "关"
    },
    on: {
      change: _vm.changeHeader
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };